import { ReactNode } from 'react';
import {
  Box,
  Container,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Stack,
  Text,
} from '@chakra-ui/react';
import { pageContentPadding } from '../../theme/tokens';

interface ContentGenerationLayoutProps {
  breadcrumb?: ReactNode;
  title: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  drawer?: {
    isOpen: boolean;
    onClose: () => void;
    title: ReactNode;
    body: ReactNode;
    footer?: ReactNode;
    size?: 'sm' | 'md' | 'lg' | 'xl';
  };
}

export function ContentGenerationLayout({
  breadcrumb,
  title,
  actions,
  children,
  drawer,
}: ContentGenerationLayoutProps) {
  return (
    <>
      <Box bg="bg.surface" w="full" h="full" overflow="auto">
        <Container maxW="full" py={pageContentPadding.y} px={pageContentPadding.x}>
          <Stack spacing="6">
            <Flex justify="space-between" alignItems="center">
              <Box>
                {breadcrumb != null ? (
                  <Text textStyle="sm" fontWeight="medium" color="fg.muted">
                    {breadcrumb}
                  </Text>
                ) : null}
                <Text as="h1" textStyle="3xl" fontWeight="medium" color="fg.default">
                  {title}
                </Text>
              </Box>
              {actions}
            </Flex>
            {children}
          </Stack>
        </Container>
      </Box>

      {drawer ? (
        <Drawer
          isOpen={drawer.isOpen}
          placement="right"
          onClose={drawer.onClose}
          size={drawer.size ?? 'md'}
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>
              <Text as="h2" textStyle="2xl" fontWeight="medium">
                {drawer.title}
              </Text>
            </DrawerHeader>
            <DrawerBody>{drawer.body}</DrawerBody>
            {drawer.footer != null ? <DrawerFooter>{drawer.footer}</DrawerFooter> : null}
          </DrawerContent>
        </Drawer>
      ) : null}
    </>
  );
}
